module.exports = __webpack_public_path__ + "static/media/icon-check-circle-active.57dc749f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-check-circle-active.svg
// module id = 1893
// module chunks = 0